import Call from '../Call.v2';

const PeerClickOffer = {
    updateDomain(oldDomain, offerId, newDomain) {
        return Call('peerclick/offers/updateDomain','PUT', { oldDomain, offerId, newDomain });
    }
};

export default PeerClickOffer;


// WEBPACK FOOTER //
// ./src/services/API/components/PeerClickOffer.js